// TabComponent.jsx

import React from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import DramaCard from './Movies/DramaCard';
import NewlyCompo from './Movies/NewlyCompo';
import DramaMovieSlide from './KidsMovieSwiper/DramaMovieSlide';
import NewlyComSlide from './Swiper/NewlyComSlide';

const TabComponent = () => {
  return (
    <Tabs>
      <TabList className="flex border-b border-gray-200">
        <Tab className="mr-1 py-2 px-4 text-gray-500 transition duration-300 ease-in-out cursor-pointer font-bold focus:border-blue-500 focus:border-b-2 focus:text-gray-900 hover:text-blue-500">
          More Like this
        </Tab>
        <Tab className="mr-1 py-2 px-4 text-gray-500 transition duration-300 ease-in-out cursor-pointer font-bold focus:border-blue-500 focus:border-b-2 focus:text-gray-900 hover:text-blue-500">
          Newly Added    </Tab>
        <Tab className="mr-1 py-2 px-4 text-gray-500 transition duration-300 ease-in-out cursor-pointer font-bold focus:border-blue-500 focus:border-b-2 focus:text-gray-900 hover:text-blue-500">
          Extras
        </Tab>
      </TabList>
      <TabPanel className="p-4">
       <DramaMovieSlide />
      </TabPanel>
      <TabPanel className="p-4">
        <NewlyComSlide />
      </TabPanel>
      <TabPanel className="p-4">

        <p className='text-md text-wrap text-gray-500'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum repellat minus iusto sit aut qui quasi dicta nemo blanditiis? Delectus nobis laboriosam ea eos at numquam accusamus error porro mollitia?</p>
      </TabPanel>
    </Tabs>
  );
};

export default TabComponent;
